import {
  AlertLayer,
  AlertLayerContent,
  Button,
  ButtonAppearance,
  FormattedHTMLMessage,
  Text,
  TextSize,
  TextTag,
} from '@yarmill/components';
import { FormEvent, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { clearAuthToken } from '../auth/utils';
import { INACTIVE_USER_ALERT_KEY } from './const';

export function InactiveUserAlert(): JSX.Element {
  async function goToLogin(e: FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    window.location.href = '/';
    return;
  }

  useEffect(() => {
    window.sessionStorage.setItem(INACTIVE_USER_ALERT_KEY, 'true');
    clearAuthToken();
  }, []);

  return (
    <AlertLayer active>
      <AlertLayerContent.AlertLayerContainer>
        <AlertLayerContent.ContentWrapper onSubmit={goToLogin}>
          <AlertLayerContent.HeadlineWrapper>
            <Text tag={TextTag.h2} size={TextSize.s16} medium>
              <FormattedMessage id="inactiveUser.headline" />
            </Text>
          </AlertLayerContent.HeadlineWrapper>
          <Text tag={TextTag.p} size={TextSize.s14}>
            <FormattedHTMLMessage id="inactiveUser.description" />
          </Text>

          <AlertLayerContent.ButtonsWrapper>
            <Button
              type="submit"
              appearance={ButtonAppearance.Primary}
              noShadow
              name="action"
              data-cy="goToLogin"
              value="goToLogin"
            >
              <FormattedMessage id="inactiveUser.button.logout" />
            </Button>
          </AlertLayerContent.ButtonsWrapper>
        </AlertLayerContent.ContentWrapper>
      </AlertLayerContent.AlertLayerContainer>
    </AlertLayer>
  );
}
